import { useEffect, useState } from "react"
import { getUser, hasRole, loadJobsReportBody, setMobileToolbar, setPage, useGlobal, useHub, useJobsReportBody } from "../../../../core/Global"
import Layout from "../../../../components/layouts/Layout"
import Section from "../../../../components/base/Section"
import FlexRow from "../../../../components/base/FlexRow"
import Indicator from "../../../../components/base/Indicator"
import { ChartTimingTypes, JobsChartSegments } from "../../../../core/Enums"
import Div from "../../../../components/base/Div"
import IconButton from "../../../../components/base/IconButton"
import JobReportModel from "../models/JobReportModel"
import JobReportCard from "../components/JobReportCard"
import JobPaymentDetails from "../../../crm/jobs/models/JobPaymentDetails"



export default function JobsReportTechMobile() {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    const user = getUser()
    const hub = useHub()
    const body = useJobsReportBody()

    const [globalState, globalStateSet] = useGlobal()

    const [loading, loadingSet] = useState<boolean>(true)
    const [loaded, loadedSet] = useState<boolean>(false)
    const [model, modelSet] = useState<JobReportModel>()

    const fetch = () => {

        loadingSet(true);

        hub.Post("/reports/jobs/chart/", {
            ...body,
            sortType: 2,
            sortKey: "closedAt"
        }, res => {
            if (res.success) {
                modelSet(res.data);
                setTimeout(() => {
                    loadingSet(false);
                    loadedSet(true);
                }, 500);
            }
        })
    }




    const Toolbar = () => {

        const [dates, datesSet] = useState<any>()

        useEffect(() => {
            if (dates) {
                globalStateSet({
                    techReportTitle: dates.label,
                    jobsReportBody: {
                        chartTiming: ChartTimingTypes.Day,
                        metric1: "",
                        metric2: "",
                        metric3: "",
                        dateId: "99",
                        segment: JobsChartSegments.Payments,
                        segmentIds: [user?.id ?? ""],
                        startDate: dates.startDate,
                        toDate: dates.toDate
                    }
                })
            }
        }, [dates])

        useEffect(() => {

            var opt: any = {};
            opt.autoApply = false;
            opt.singleDatePicker = false;

            const d = window.datepicker("tech-filter-date", opt)

            d.on('apply.daterangepicker', function (e: any, p: any) {

                var dateLabel = p.startDate.format("DD MMM") + " - " + p.endDate.format("DD MMM");

                datesSet({
                    startDate: p.startDate.format("DD/MM/YYYY"),
                    toDate: p.endDate.format("DD/MM/YYYY"),
                    label: dateLabel
                })

            });

        }, [])

        return (
            <FlexRow>
                <IconButton id="tech-filter-date" icon="calendar-lines" type="regular" size={22} />
                <IconButton icon="arrow-up-from-square" type="regular" size={20} />
            </FlexRow>
        )
    }

    useEffect(() => {
        if (body) fetch();
    }, [body])

    useEffect(() => {
        setPage("Report")
        setMobileToolbar(Toolbar)

        return () => {
            setMobileToolbar(undefined)
        }
    }, [])

    const [jobsTotalRow, jobsTotalRowSet] = useState<JobPaymentDetails>();

    useEffect(() => {
        if (model?.jobs) {

            var total: JobPaymentDetails = {
                amount: 0,
                totalCash: 0,
                totalCCCharge: 0,
                totalCCManual: 0,
                totalCCChargeRate: 0,
                totalCheck: 0,
                companyParts: 0,
                techParts: 0,
                companyProfit: 0,
                totalTaxRate: 0,
                techProfit: 0,
                sourceProfit: 0,
                techBalance: 0,
                techFee: 0
            };

            model.jobs.forEach(j => {
                total.amount! += (j.payment?.totalPayment ?? 0);
                total.totalCash! += (j.paymentDetails?.totalCash ?? 0);
                total.totalCCCharge! += (j.paymentDetails?.totalCCCharge ?? 0);
                total.totalCCManual! += (j.paymentDetails?.totalCCManual ?? 0);
                total.totalCheck! += (j.paymentDetails?.totalCheck ?? 0);
                total.companyParts! += (j.paymentDetails?.companyParts ?? 0);
                total.techParts! += (j.paymentDetails?.techParts ?? 0);
                total.companyProfit! += (j.paymentDetails?.companyProfit ?? 0);
                total.totalTaxRate! += (j.paymentDetails?.totalTaxRate ?? 0);
                total.techProfit! += (j.paymentDetails?.techProfit ?? 0);
                total.sourceProfit! += (j.paymentDetails?.sourceProfit ?? 0);
                total.techBalance! += (j.paymentDetails?.techBalance ?? 0);
                total.totalCCChargeRate! += (j.paymentDetails?.totalCCChargeRate ?? 0);
                total.techFee! += j.paymentDetails?.techFee ?? 0;
            })

            jobsTotalRowSet(total);

        }
    }, [model])


    const balanceBG = () => {
        if (!jobsTotalRow?.techBalance) return "bg-secondary";
        if (jobsTotalRow.techBalance < 0) return "bg-danger";
        if (jobsTotalRow.techBalance >= 0) return "bg-success";

        return "bg-secondary";
    }


    if (!hasRole("TechViewReports")) return (<></>)

    return (
        <Layout wide>
            <Section fluid>

                <Div visible={loading} className="mt-20 text-center fs-4">
                    <Indicator />
                </Div>

                <Div visible={loaded && !loading && (model != undefined)}>

                    <FlexRow className="mt-5">
                        <h1>
                            {globalState.techReportTitle}
                        </h1>

                        {
                            globalState.techReportTitle != "Current Week" &&
                            <div className="ms-auto">
                                <button className="btn btn-light-primary btn-active-light-primary btn-sm"
                                    onClick={e => {
                                        loadJobsReportBody(user!)
                                    }}>
                                    Current Week
                                </button>
                            </div>
                        }
                    </FlexRow>

                    <div className="row mt-5 mb-5">

                        <div className="col-6">
                            <div className="card overflow-hidden h-md-50">
                                <div className="card-body bg-primary d-flex justify-content-between flex-column px-0 pb-0">
                                    <div className="mb-4 px-4" style={{ minWidth: 200 }}>
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="align-self-start text-white me-1" style={{ fontSize: 28, fontWeight: 200 }}>
                                                $
                                            </span>
                                            <span className="fs-2hx fw-bolder text-white me-2 lh-1">
                                                {moneyFormatter.format(jobsTotalRow?.techProfit ?? 0).replace("$", "")}
                                            </span>
                                        </div>
                                        <span className="fs-6 fw-bold text-gray-100">Total Profit</span>
                                    </div>
                                    <div className="min-h-auto" style={{ height: 20 }}></div>
                                </div>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="card overflow-hidden h-md-50">
                                <div className={`card-body ${balanceBG()} d-flex justify-content-between flex-column px-0 pb-0`}>
                                    <div className="mb-4 px-4" style={{ minWidth: 200 }}>
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="align-self-start text-white me-1" style={{ fontSize: 28, fontWeight: 200 }}>
                                                $
                                            </span>
                                            <span className="fs-2hx fw-bolder text-white me-2 lh-1">
                                                {(jobsTotalRow?.techBalance ?? 0) < 0 ? "" : "+"}
                                                {moneyFormatter.format(jobsTotalRow?.techBalance ?? 0).replace("$", "")}
                                            </span>
                                        </div>
                                        <span className="fs-6 fw-bold text-gray-100">Balance</span>
                                    </div>
                                    <div className="min-h-auto" style={{ height: 20 }}></div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div>
                        {
                            model?.jobs?.map((job, key) =>
                                <JobReportCard key={key} job={job} />
                            )
                        }
                    </div>

                    <div className="h-100px">

                    </div>

                </Div>

            </Section>
        </Layout>
    )
}